import { VoltageClass } from '@ebalance/proto/bffuser/v1/occto_master_model_pb'
import i18next from 'i18next'

/**
 * VoltageClass の表示ラベルを返す (OCCTO マスタの各タブで共通)。
 * UNSPECIFIED は空文字を返す (= 選択未了の状態)。
 */
export function voltageClassLabel(
  voltageClass: VoltageClass | undefined,
): string {
  if (voltageClass === undefined || voltageClass === VoltageClass.UNSPECIFIED) {
    return ''
  }
  const t = i18next.t.bind(i18next)
  switch (voltageClass) {
    case VoltageClass.EXTRA_HIGH:
      return t('page:adminOcctoMaster.plantMaster.voltageClass.extraHigh')
    case VoltageClass.HIGH:
      return t('page:adminOcctoMaster.plantMaster.voltageClass.high')
    case VoltageClass.LOW:
      return t('page:adminOcctoMaster.plantMaster.voltageClass.low')
    default:
      return ''
  }
}
